import styled from "styled-components";

export const StyledButtonFooterConfirmCmSheet = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;
